<script setup lang="ts">
import AppPlaceholder from './AppPlaceholder.vue';

</script>

<template>
	<div class="group relative flex flex-col justify-center text-center p-6 z-0 bg-primary-500 h-full w-full min-w-[240px] rounded-xl space-y-9">
		<div class="flex flex-col justify-center items-center space-y-2">
			<AppPlaceholder class="w-1/3 h-2" />
			<AppPlaceholder class="w-2/3 h-4" />
			<AppPlaceholder class="w-1/2 h-8" />
		</div>
		<div class="flex flex-col justify-center items-center space-y-2">
			<AppPlaceholder class="w-1/3 h-2 mx-auto" />
			<AppPlaceholder class="w-2/3 h-10 mx-auto" />
		</div>
		<div class="flex items-center justify-center w-full space-x-2">
			<AppPlaceholder class="w-1/3 h-8" />
			<AppPlaceholder class="w-8 h-8" />
		</div>
	</div>
</template>
